import { CanActivateFn } from '@angular/router';
import { AuthenticatorService } from '../core/authenticator.service';
import { inject } from '@angular/core';
import { Router } from '@angular/router';

export const accountGuard: CanActivateFn = () => {
  const authenticator = inject(AuthenticatorService)
  const router = inject(Router)

  if (authenticator.isAuthed) {
    return true
  }

  // Редиректим на логин и передаем текущий URL как redirect_uri
  router.navigate(['/auth/login'], {
    queryParams: {
      'client_id': 'self',
      'redirect_uri': window.location.href,
      'skip_launcher': '1'
    }
  })
  return false
}
